export default {
    mask: [
        '# ₸',
        '## ₸',
        '### ₸',
        '# ### ₸',
        '## ### ₸',
        '### ### ₸',
        '# ### ### ₸',
        '## ### ### ₸',
        '### ### ### ₸',
    ],
}
